import {useCallback, useRef, useState} from 'react';
import {Link, useLocation, useNavigate} from "react-router-dom";
import Form, {ButtonItem, ButtonOptions, Item, Label, RequiredRule, SimpleItem,} from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';
import {checkAnswer} from '../../../api/auth';
import './ForgotPasswordQuestionForm.scss';
import 'devextreme-react/text-area';
import RECAPTCHA from 'react-google-recaptcha';
import {RECAPTCHA_SITE_KEY} from "../../../config/constants";
import {Template} from "devextreme-react/core/template";

const notificationText = 'We\'ve sent a link to reset your password. Check your inbox.';

export default function ForgotPasswordQuestionForm() {
    const captchaRef = useRef<RECAPTCHA>(null)
    const { state } = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const formData = useRef({ answer: '', question: state.question, token: '' });

    const onSubmit = useCallback(async (e: any) => {
        e.preventDefault();
        const { answer } = formData.current;
        let token: string = '';
        if (captchaRef !== null) {
            let current = captchaRef.current;
            if (current !== null) {
                token = current.getValue() ?? '';
                current.reset();
            }
        }
        setLoading(true);

        const result = await checkAnswer(state.userName, state.environment, answer, token);
        setLoading(false);

        if (result.isOk) {
            navigate('/login');
            notify(notificationText, 'success', 2500);
        } else {
            notify(result.message, 'error', 2000);
        }
    }, [navigate]);

    return (
        <form className={'forgot-password-question-form'} onSubmit={onSubmit}>
            <Form formData={formData.current} disabled={loading} requiredMark={""}>
                <Item dataField={'question'} editorType="dxTextArea" editorOptions={questionOptions}>
                    <Label visible={false} />
                </Item>
                <Item
                    dataField={'answer'}
                    editorType={'dxTextBox'}
                    editorOptions={answerEditorOptions}
                >
                    <RequiredRule message="Answer is required" />
                    <Label visible={false} />
                </Item>
                <SimpleItem dataField={'token'} template={'testTemplate'}>
                    <Label visible={false} />
                </SimpleItem>
                <Template name={'testTemplate'}>
                    <RECAPTCHA sitekey={RECAPTCHA_SITE_KEY} ref={captchaRef} />
                </Template>

                <ButtonItem>
                    <ButtonOptions
                        elementAttr={submitButtonAttributes}
                        width={'100%'}
                        type={'default'}
                        useSubmitBehavior={true}
                    >
                        <span className="dx-button-text">
                            {
                                loading
                                    ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                                    : 'Continue'
                            }
                        </span>
                    </ButtonOptions>
                </ButtonItem>
                <Item>
                    <div className={'login-link'}>
                        Return to <Link to={'/login'}>Login</Link>
                    </div>
                </Item>
            </Form>
        </form>
    );
}

const answerEditorOptions = { stylingMode: 'outlined', labelMode: 'floating', placeholder: 'Answer', mode: 'text' };
const questionOptions = { height: 120, readOnly: true, stylingMode: 'outlined', labelMode: 'floating' };
const submitButtonAttributes = { class: 'submit-button' };
